import { render, staticRenderFns } from "./UIOrderBookModal.vue?vue&type=template&id=1c7637b4&scoped=true"
import script from "./UIOrderBookModal.vue?vue&type=script&lang=js"
export * from "./UIOrderBookModal.vue?vue&type=script&lang=js"
import style0 from "./UIOrderBookModal.vue?vue&type=style&index=0&id=1c7637b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7637b4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/skade-pwa/components/ui/atom/buttons/Button.vue').default})
